import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: null,
    homeVisited: false,
    searchText: '',
    appStatus: 'activeOnly',
    appType: 'all',
    ward: 'all',
    orderBy: 'default',
    orderType: 'asc',
    allDevApps: null,
    allFeatures: null,
    searchResults: null,
    searchIndex: 0,
    bounds: '0,0,0,0',
    currentDevapp: null
  },
  mutations: {
    lang (state, lang) {
      state.lang = lang
    },
    homeVisited (state) {
      state.homeVisited = true
    },
    allDevApps (state, allDevApps) {
      state.allDevApps = allDevApps
    },
    allFeatures (state, allFeatures) {
      state.allFeatures = allFeatures
    },
    searchText (state, searchText) {
      state.searchText = searchText
    },
    appStatus (state, appStatus) {
      state.appStatus = appStatus
    },
    appType (state, appType) {
      state.appType = appType
    },
    ward (state, ward) {
      state.ward = ward
    },
    orderBy (state, orderBy) {
      state.orderBy = orderBy
    },
    orderType (state, orderType) {
      state.orderType = orderType
    },
    searchResults (state, searchResults) {
      state.searchResults = searchResults
    },
    searchIndex (state, searchIndex) {
      state.searchIndex = searchIndex
    },
    bounds (state, bounds) {
      state.bounds = bounds
    },
    currentDevapp (state, currentDevapp) {
      state.currentDevapp = currentDevapp
    },
    resetSearch (state) {
      state.searchText = '',
      state.appStatus = 'activeOnly',
      state.appType = 'all',
      state.ward = 'all',
      state.orderBy = 'default',
      state.orderType = 'asc',
      state.searchResults = null,
      state.searchIndex = 0,
      state.bounds = '0,0,0,0'
      state.currentDevapp = null
    },
    resetDevapp (state) {
      state.currentDevapp = null
    },
    resetBounds(state) {
      state.bounds = '0,0,0,0'
    }
  },
  getters: {
    isEmptySearch: state => { return state.searchResults === null } 
  },
  actions: {
  },
  modules: {
  }
})
